import { aiMonthlyCreditsByPlanKey } from "@shared/lib/planHelpers";

/* Current Organization Plans (for new customers and current pricing)
--===================================================-- */
export const currentOrganizationPlanOptions = [
  {
    value: "plan_ats_tier_free_v2",
    label: "Free",
    jobLimit: 1,
    userLimit: "unlimited",
    period: "monthly",
    key: "free",
  },
  {
    value: "plan_ats_tier_starter_v2",
    label: "Starter",
    jobLimit: 5,
    userLimit: "unlimited",
    period: "monthly",
    key: "starter_v2",
  },
  {
    value: "plan_ats_tier_growth_v2",
    label: "Growth",
    jobLimit: 20,
    userLimit: "unlimited",
    period: "monthly",
    key: "growth_v2",
  },
  {
    value: "plan_ats_tier_scale_v2",
    label: "Scale",
    jobLimit: 50,
    userLimit: "unlimited",
    period: "monthly",
    key: "scale_v2",
  },
  {
    value: "plan_ats_tier_free_v2",
    label: "Free",
    jobLimit: 1,
    userLimit: "unlimited",
    period: "yearly",
    key: "free",
  },
  {
    value: "plan_ats_tier_starter_v2",
    label: "Starter",
    jobLimit: 5,
    userLimit: "unlimited",
    period: "yearly",
    key: "starter_v2",
  },
  {
    value: "plan_ats_tier_growth_v2",
    label: "Growth",
    jobLimit: 20,
    userLimit: "unlimited",
    period: "yearly",
    key: "growth_v2",
  },
  {
    value: "plan_ats_tier_scale_v2",
    label: "Scale",
    jobLimit: 50,
    userLimit: "unlimited",
    period: "yearly",
    key: "scale_v2",
  },
  {
    value: "plan_ats_tier_enterprise",
    label: "Enterprise",
    jobLimit: "unlimited",
    userLimit: "unlimited",
    period: "custom",
    key: "enterprise",
  },
];

/* Legacy Plan Options (for button text logic and upgrades)
--===================================================-- */
export const legacyOrganizationPlanOptions = [
  // Legacy free plans
  {
    value: "plan_ats_tier_free",
    label: "Free Legacy",
    jobLimit: 0,
    userLimit: "unlimited",
    period: "monthly",
    key: "free_legacy",
  },
  {
    value: "plan_simple_ats_free",
    label: "Free Legacy",
    jobLimit: 0,
    userLimit: "unlimited",
    period: "monthly",
    key: "free_legacy",
  },
  {
    value: "plan_no_plan",
    label: "No Plan",
    jobLimit: 0,
    userLimit: "unlimited",
    period: "monthly",
    key: "no_plan",
  },

  // Legacy v1 plans - unlimited users, job limits
  {
    value: "plan_ats_tier_starter",
    label: "Starter Legacy",
    jobLimit: 5,
    userLimit: "unlimited",
    period: "monthly",
    key: "starter_monthly_v1",
  },
  {
    value: "plan_ats_tier_starter",
    label: "Starter Legacy",
    jobLimit: 5,
    userLimit: "unlimited",
    period: "yearly",
    key: "starter_annual_v1",
  },
  {
    value: "plan_ats_tier_growth",
    label: "Growth Legacy",
    jobLimit: 20,
    userLimit: "unlimited",
    period: "monthly",
    key: "growth_monthly_v1",
  },
  {
    value: "plan_ats_tier_growth",
    label: "Growth Legacy",
    jobLimit: 20,
    userLimit: "unlimited",
    period: "yearly",
    key: "growth_annual_v1",
  },
  {
    value: "plan_ats_tier_scale",
    label: "Scale Legacy",
    jobLimit: 50,
    userLimit: "unlimited",
    period: "monthly",
    key: "scale_monthly_v1",
  },
  {
    value: "plan_ats_tier_scale",
    label: "Scale Legacy",
    jobLimit: 50,
    userLimit: "unlimited",
    period: "yearly",
    key: "scale_annual_v1",
  },

  // Legacy unlimited plans
  {
    value: "plan_simple_ats_paid",
    label: "Unlimited Legacy",
    jobLimit: "unlimited",
    userLimit: "unlimited",
    period: "monthly",
    key: "unlimited_legacy",
  },
  {
    value: "plan_simple_ats_per_job",
    label: "Per Job Legacy",
    jobLimit: "unlimited",
    userLimit: "unlimited",
    period: "monthly",
    key: "per_job_legacy",
  },
  {
    value: "plan_ats_tier_apollo",
    label: "Apollo Legacy",
    jobLimit: "unlimited",
    userLimit: "unlimited",
    period: "monthly",
    key: "apollo_legacy",
  },
];

/* All Plan Options (combined for button text logic)
--===================================================-- */
export const allOrganizationPlanOptions = [
  ...currentOrganizationPlanOptions,
  ...legacyOrganizationPlanOptions,
];

/* Plan Features Data
--===================================================-- */
export const oldPlanFeatures = [
  {
    name: "Unlimited Users",
    description: "Add unlimited team members to your account",
    free: true,
    starter: true,
    growth: true,
    scale: true,
    enterprise: true,
    includeTooltip: false,
    gated: false,
  },
  {
    name: "Unlimited Candidates",
    description: "Store unlimited candidate profiles and applications",
    free: true,
    starter: true,
    growth: true,
    scale: true,
    enterprise: true,
    includeTooltip: false,
    gated: false,
  },
  {
    name: "Branded company job board",
    description: "Create and publish unlimited job postings on your hosted careers site",
    free: true,
    starter: true,
    growth: true,
    scale: true,
    enterprise: true,
    includeTooltip: false,
    gated: false,
  },
  {
    name: "Custom job categories",
    description: "Organize your job postings with custom categories",
    free: true,
    starter: true,
    growth: true,
    scale: true,
    enterprise: true,
    includeTooltip: false,
    gated: false,
  },
  {
    name: "Custom application form questions",
    description: "Add custom text, yes/no, and other question types",
    free: true,
    starter: true,
    growth: true,
    scale: true,
    enterprise: true,
    includeTooltip: false,
    gated: false,
  },
  {
    name: "Multi-language job board support",
    description: "Localize your careers site in multiple languages",
    free: true,
    starter: true,
    growth: true,
    scale: true,
    enterprise: true,
    includeTooltip: false,
    gated: false,
  },
  {
    name: "Job board API & developer access",
    description: "Full API access for custom integrations",
    free: true,
    starter: true,
    growth: true,
    scale: true,
    enterprise: true,
    includeTooltip: false,
  },
  {
    name: "Custom domain for job board",
    description: "Use your own URL for your careers page",
    free: false,
    starter: true,
    growth: true,
    scale: true,
    enterprise: true,
    includeTooltip: false,
    gated: true,
    gateKey: "CUSTOM_DOMAIN",
  },
  {
    name: "Built-in job distribution",
    description: "Auto-indexed on Google Jobs with SEO and direct apply support",
    free: false,
    starter: true,
    growth: true,
    scale: true,
    enterprise: true,
    includeTooltip: false,
    gated: true,
    gateKey: "GOOGLE_JOBS_INTEGRATION",
  },
  {
    name: "File upload fields on applications",
    description: "Allow candidates to attache resumes and portfolios",
    free: false,
    starter: true,
    growth: true,
    scale: true,
    enterprise: true,
    includeTooltip: false,
    gated: true,
    gateKey: "CUSTOM_FILE_UPLOAD_APPLICATION_FIELDS",
  },
  {
    name: "Automatic confirmation emails",
    description: "Send automatic confirmation emails to applicants",
    free: false,
    starter: true,
    growth: true,
    scale: true,
    enterprise: true,
    includeTooltip: false,
    gated: true,
    gateKey: "CUSTOM_CONFIRMATION_EMAILS",
  },
  {
    name: "Social media sharing tools",
    description: "Quick post to LinkedIn/Twitter with tracking links",
    free: false,
    starter: true,
    growth: true,
    scale: true,
    enterprise: true,
    includeTooltip: false,
  },
  {
    name: "Job post rich media",
    description: "Add video headers and map embeds to job posts",
    free: false,
    starter: true,
    growth: true,
    scale: true,
    enterprise: true,
    includeTooltip: false,
    gated: true,
    gateKey: "JOB_POST_RICH_MEDIA",
  },
  {
    name: "Custom social share images",
    description: "Improve link previews when sharing job posts",
    free: false,
    starter: true,
    growth: true,
    scale: true,
    enterprise: true,
    includeTooltip: false,
    gated: true,
    gateKey: "CUSTOM_SOCIAL_SHARE_IMAGES",
  },
  {
    name: "LinkedIn Limited Listings integration",
    description: "Auto-post jobs to your LinkedIn Company Page",
    free: false,
    starter: true,
    growth: true,
    scale: true,
    enterprise: true,
    includeTooltip: false,
    gated: true,
    gateKey: "LINKEDIN_FEED",
  },
  {
    name: "Job seeker subscriptions",
    description:
      "Allow candidates to subscribe to job alerts and receive notifications when new jobs are posted",
    free: false,
    starter: true,
    growth: true,
    scale: true,
    enterprise: true,
    includeTooltip: false,
    gated: true,
    gateKey: "JOB_SEEKER_SUBSCRIPTIONS",
  },
  {
    name: "Third-party job boards integration",
    description: "Post to We Work Remotely via Polymer UI",
    free: false,
    starter: true,
    growth: true,
    scale: true,
    enterprise: true,
    gated: true,
    gateKey: "WE_WORK_REMOTELY_INTEGRATION",
  },
  // {
  //   name: "Slack and Discord notifications",
  //   description: "Get notified when new candidates apply or when new messages are received",
  //   free: false,
  //   starter: true,
  //   growth: true,
  //   scale: true,
  //   enterprise: true,
  //   includeTooltip: false,
  //   gated: true,
  //   gateKey: "SLACK_INTEGRATION",
  // },
  {
    name: "Stage Based Candidate Message Automation",
    description: "Send automated template messages to candidates based on their stage",
    free: false,
    starter: false,
    growth: true,
    scale: true,
    enterprise: true,
    includeTooltip: false,
    gated: true,
    gateKey: "HIRING_STAGE_MESSAGE_AUTOMATIONS",
  },
  {
    name: "Bulk Candidate Messaging",
    description: "Send messages to multiple candidates by stage or custom selection",
    free: false,
    starter: false,
    growth: true,
    scale: true,
    enterprise: true,
    includeTooltip: false,
    gated: true,
    gateKey: "BULK_MESSAGE",
  },
  {
    name: "Custom User Roles & Permissions",
    description: "Control access levels for interviewers and team members",
    free: false,
    starter: false,
    growth: true,
    scale: true,
    enterprise: true,
    includeTooltip: false,
    gated: true,
    gateKey: "INTERVIEWER_ROLE",
  },
  {
    name: "X (Twitter) Hiring integration",
    free: false,
    starter: false,
    growth: true,
    scale: true,
    enterprise: true,
    includeTooltip: false,
    gated: true,
    gateKey: "X_HIRING_FEED",
  },
  {
    name: "White-label branding",
    description: 'Remove "Powered by Polymer" footer for fully branded careers site',
    free: false,
    starter: false,
    growth: false,
    scale: true,
    enterprise: true,
    includeTooltip: false,
    gated: true,
    gateKey: "WHITE_LABEL_JOB_BOARD",
  },
];

/* Job Limit Features - Dynamic per plan */
const createJobLimitFeature = (planKey) => {
  const plan = allOrganizationPlanOptions.find((plan) => plan.key === planKey);
  const name = `Up to ${plan.jobLimit} published ${plan.jobLimit === 1 ? "job" : "jobs"}`;
  return {
    name: name,
    description: "Number of jobs you can have published at once",
    included: true,
    includeTooltip: false,
  };
};

/* Plato AI Credit Features - Dynamic per plan */
const createAiCreditFeature = (planKey) => {
  const monthlyCredits = aiMonthlyCreditsByPlanKey[planKey];
  return {
    name: `${monthlyCredits} Plato AI ${monthlyCredits === 1 ? "credit" : "credits"} per month`,
    description: "Plato AI candidate reviews included with your plan each month",
    included: true,
    includeTooltip: false,
  };
};

/* User Limit Features - Dynamic per plan */
const createUserLimitFeature = (planKey) => {
  const plan = allOrganizationPlanOptions.find((plan) => plan.key === planKey);
  let name;
  if (plan.userLimit === "unlimited") {
    name = "Unlimited users";
  } else {
    name = `Up to ${plan.userLimit} active ${plan.userLimit === 1 ? "user" : "users"}`;
  }
  return {
    name: name,
    description: "Number of team members you can add to your account",
    included: true,
    includeTooltip: false,
  };
};

export const getPlanFeaturesOld = (planKey) => {
  // Map oldPlanFeatures to the correct included status for this plan
  const features = oldPlanFeatures.map((feature) => ({
    name: feature.name,
    description: feature.description,
    included: !!feature[planKey],
    value: feature.value || null,
    includeTooltip: feature.includeTooltip || false,
  }));

  const jobLimitFeature = createJobLimitFeature(planKey);

  return [jobLimitFeature, ...features];
};

// New function focusing on limits for cohesive card design
export const getPlanLimits = (planKey) => {
  const jobLimitFeature = createJobLimitFeature(planKey);
  const aiCreditFeature = createAiCreditFeature(planKey);
  const userLimitFeature = createUserLimitFeature(planKey);

  const limits = [jobLimitFeature, aiCreditFeature, userLimitFeature];

  // Add special features based on plan
  if (planKey === "free") {
    // Free plan: Add limitations feature with array of limitations
    const freeLimitations = getFreePlanLimitations();
    limits.push({
      name: "Limitations apply",
      description: freeLimitations, // Pass the array directly
      included: false,
      includeTooltip: true,
      isLimitation: true,
      limitations: freeLimitations, // Also store as separate property for clarity
    });
  } else if (planKey === "scale_v2") {
    // Scale plan: White Labeling available
    limits.push({
      name: "White-label branding",
      description: 'Remove "Powered by Polymer" footer for fully branded careers site',
      included: true,
      includeTooltip: false,
    });
  }

  return limits;
};

// Helper function to get free plan limitations (not features)
export const getFreePlanLimitations = () => {
  return [
    {
      name: "Messaging",
      description: "Messaging features are not available on Free plan",
      tooltipText: "Upgrade to access messaging features",
    },
    {
      name: "LinkedIn integration",
      description: "LinkedIn integration is not available on Free plan",
      tooltipText: "Upgrade to access LinkedIn integration",
    },
  ];
};

export const getPlansForPeriod = (period, billingPrices = []) => {
  const planConfigs = currentOrganizationPlanOptions.filter((plan) => plan.period === period);
  const planDataMatches = billingPrices.filter((price) =>
    period.includes(price?.recurring?.interval),
  );

  return planConfigs.map((planConfig) => {
    const priceData = planDataMatches.find((price) => price.lookupKey.includes(planConfig.key));

    return {
      name: planConfig.label,
      price: priceData ? priceData.unitAmount / 100 : 0,
      period: planConfig.period,
      jobLimit: planConfig.jobLimit,
      userLimit: planConfig.userLimit,
      priceId: priceData?.id || null,
      lookupKey: planConfig.value,
      features: getPlanLimits(planConfig.key),
      key: planConfig.key,
    };
  });
};

/* Plan Button Text Logic
--===================================================-- */
export const getPlanButtonType = (buttonText) => {
  // Make primary for upgrade/start actions, secondary for other changes
  if (buttonText === "Upgrade" || buttonText === "Start plan" || buttonText === "Start free trial") {
    return "primary";
  }
  return "secondary";
};

export const getUnsubscribedPlanButtonText = (hasNeverSubscribed) => {
  if (hasNeverSubscribed) {
    return "Start free trial";
  } else {
    return "Start plan";
  }
};

export const getPlanButtonText = (currentPlanLookupKey, targetPlanLookupKey, targetPeriod) => {
  // Find the plans by their lookup keys and period from ALL options
  const currentPlan = allOrganizationPlanOptions.find(
    (plan) => {
      return currentPlanLookupKey.includes(plan.key);
    },
  );

  // Should this be current plan options instead for the target plan?
  const targetPlan = allOrganizationPlanOptions.find(
    (plan) => targetPlanLookupKey.includes(plan.key) && targetPeriod.includes(plan.period),
  );

  if (!currentPlan || !targetPlan) {
    return "Change plan"; // fallback
  }

  if (targetPlan.jobLimit === currentPlan.jobLimit) {
    if (targetPlan.key === currentPlan.key && !targetPeriod.includes(currentPlan.period)) {
      console.log("changing to target period");
      return `Change to ${targetPeriod}`;
    }
  }

  return targetPlan.jobLimit > currentPlan.jobLimit ? "Upgrade" : "Change plan";
};
